import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {Carousel} from 'react-bootstrap';
import './Slider.css';

const captionStyle = {
    textAlign: 'left',
    bottom: '30%'
}

function MostrarElemento(props) {

  const esImagen = props.mostrarElemento;
  
  if (esImagen){
    return <img className="imagen-banner" src={props.slide.fields.Imagen[0].thumbnails.full.url} alt="" />
  }
  return <video autoPlay muted>
          <source src={props.slide.fields.Video[0].url} type="video/mp4"/>
         </video>

}

class Slider extends Component {
  constructor(){
    super();
    this.state = {
      slider : ""
    }
  }

  componentDidMount(){
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer pat6jAlLNNigrNUEE.b55c43506b2f3705ce219e322d78ae26763b9233d82db88ffeacfab50cf55d98");
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: 'GET',
      headers: myHeaders
    };

    fetch("https://api.airtable.com/v0/appwgFjdijimamLnp/Home-Banner", requestOptions)
    .then(resp=>resp.json())
    .catch(error=>console.error(error))
    .then(data => {
      
      let datos = data.records.filter(record => record.fields.Activo === true) //desmarcar para testear videos en banner: || record.fields.Name == "videotest")
      this.setState({
        slider: datos
      })
    
    });
  }

  render(){
    return (
      <div style={{textAlign: 'center'}}>
        <Carousel
          controls={false}
          wrap={true}
        >
        {this.state.slider.length > 0 && this.state.slider.map((slide,index)=>

          <Carousel.Item key={`img${index}`} className="slide-image">
            <div className="gradient-slider banner-size" >

              <MostrarElemento mostrarElemento={slide.fields.Imagen} slide={slide}/>

            </div>
            <Carousel.Caption style={captionStyle}>
            <h3>
              <span dangerouslySetInnerHTML={{ __html: slide.fields.Subtitulo && slide.fields.Subtitulo }} />
            </h3>
            <h2>
              <span dangerouslySetInnerHTML={{ __html: slide.fields.Titulo && slide.fields.Titulo }} />
            </h2>
            {slide.fields.Link &&
              <Link to={slide.fields.CursoEnlazado ? "/" + 
                slide.fields.Link.split('/')[3] + "/" +
                slide.fields.Link.split('/')[4] + "/" +
                slide.fields.CursoEnlazado[0] 
              : slide.fields.Link.replace("http://dbp.flacso.org.ar", "")}>
              <span className="rm-btn el-btn-regular">Detalle</span>
              </Link>
            }
            </Carousel.Caption>
          </Carousel.Item>

          )}
        </Carousel>
      </div>
    )
  }
}

export default Slider;
